import React from 'react';

const SEOSchema = ({ data }) => {
    return (
        <script type="application/ld+json">
            {JSON.stringify(data)}
        </script>
    );
};

export default SEOSchema;
